import React from 'react'
import { Tooltip } from 'components/Form'
import { WarningHeaderStyles } from './Style'

const WarningHeader = (props) => {
    const { label, tooltip } = props

    return (
        <WarningHeaderStyles>
            <div className='label'>{label}</div>
            <Tooltip title={tooltip} />
        </WarningHeaderStyles>
    )
}

export default WarningHeader